import type { CabinClass } from '../../../domain/models/contracts';
import type { CostKey, LeakageKey, WaterfallBarId } from './routeMetrics';

/**
 * Hex palette for Recharts. SVG presentation attributes are the most reliable
 * place for literal colours, so charts use these rather than CSS variables.
 * Keep in sync with the custom properties in RouteAnalyticsInspector.css.
 */
export const CHART_COLORS = {
  grid: '#e2e8f0',
  axis: '#6b7280',
  text: '#1f2933',
  tooltipBg: '#ffffff',
  tooltipBorder: '#e2e8f0',
  loadFactor: '#2563eb',
  profitPositive: '#047857',
  profitNegative: '#dc2626',
} as const;

export const WATERFALL_COLORS: Readonly<Record<WaterfallBarId, string>> = {
  potential: '#6b7280',
  unmet: '#dc2626',
  carried: '#047857',
};

export const LEAKAGE_COLORS: Readonly<Record<LeakageKey, string>> = {
  capacitySpill: '#d97706',
  priceLeakage: '#dc2626',
  scheduleLeakage: '#7c3aed',
  comfortLeakage: '#2563eb',
};

/** One line colour per seat class, for the elasticity curves. */
export const CABIN_COLORS: Readonly<Record<CabinClass, string>> = {
  ECONOMY: '#2563eb',
  PREMIUM_ECONOMY: '#047857',
  BUSINESS: '#d97706',
  FIRST: '#7c3aed',
};

export const TOOLTIP_STYLE = {
  backgroundColor: CHART_COLORS.tooltipBg,
  border: `1px solid ${CHART_COLORS.tooltipBorder}`,
  borderRadius: 8,
  color: CHART_COLORS.text,
  fontSize: 12,
} as const;

export const COST_COLORS: Readonly<Record<CostKey, string>> = {
  fuel: '#d97706',
  airport: '#dc2626',
  crewMaintenance: '#2563eb',
  capital: '#7c3aed',
};
